import { useState } from 'react'
import {
  Alert,
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  CardText,
  Col,
  ListGroup,
  ListGroupItem,
  Row,
  Spinner,
} from 'reactstrap'
import {
  ArrowLeft,
  ArrowRight,
  CheckCircle,
  Mail,
  Smartphone,
} from 'react-feather'

import '@styles/react/libs/flatpickr/flatpickr.scss'

// ** Styles
import '@styles/react/libs/react-select/_react-select.scss'
import axios from 'axios'
import toast from 'react-hot-toast'
const SendingOTP = ({ stepper, dataOTP, showTC, setTypeOTP }) => {
  const [selected, setSelected] = useState(null)
  const [loading, setLoading] = useState(false)
  const [sent, setSent] = useState(false)
  const TIME_AWAIT = 1000

  // console.log("dataOTP", dataOTP);

  const generateOTPEmail = async () => {
    setTypeOTP('email')
    return await axios.post(
      `${process.env.REACT_APP_API_URL}/clients/generateOtp`,
      {
        email: dataOTP.email,
        isEmail: true,
        phone: '',
        isPhone: false,
        otp: '',
      }
    )
  }

  const generateOTPPhone = async () => {
    setTypeOTP('phone')
    return await axios.post(
      `${process.env.REACT_APP_API_URL}/clients/generateOtp`,
      {
        email: '',
        isEmail: false,
        phone: dataOTP.phone,
        isPhone: true,
        otp: '',
      }
    )
  }

  const sentAction = () => {
    stepper.next()
    setSent(false)
    setSelected(null)
  }

  const generateOTP = async () => {
    if (sent) {
      sentAction()
    } else {
      try {
        setLoading(true)

        if (selected === 'email') {
          await generateOTPEmail()
        }

        if (selected === 'phone') {
          await generateOTPPhone()
        }

        setLoading(false)
        setSent(true)

        setTimeout(() => {
          sentAction()
        }, TIME_AWAIT)
      } catch (e) {
        console.error(e.message)
        toast.error(`Ha ocurrido un error inesperado: ${e.message}`)
        setLoading(false)
        setSent(false)
      }
    }
  }

  return (
    <div className="col-lg-8 col-md-12 col-sm-12 py-4 m-auto">
      <Card className={'px-3 py-3'}>
        <CardHeader>
          <h2 className="brand-text mb-0 text-primary">RubriDoc</h2>
          <span className="float-end">Validación de identidad</span>
        </CardHeader>
        <CardBody className={'pb-0'}>
          <hr />

          {loading && (
            <div className="row">
              <div className="col-12 px-2 py-4 text-center">
                <Spinner size="lg" />
                <CardText className={'py-1 fs-5'}>
                  Enviando código de validación...
                </CardText>
              </div>
            </div>
          )}

          {!loading && !sent && (
            <>
              <h3>Enviar código de validación</h3>
              <ListGroup
                tag="div"
                className={'pt-2'}
              >
                <ListGroupItem
                  action
                  tag="a"
                  href="#!"
                  style={{
                    backgroundColor: selected === 'email' && '#2356b3',
                    color: selected === 'email' && '#fff',
                  }}
                  onClick={(e) => {
                    e.preventDefault()
                    setSelected('email')
                  }}
                >
                  <Row>
                    <Col
                      lg={{ size: 1, order: 0 }}
                      md={{ size: 2, order: 0 }}
                      xs={{ size: 2, order: 0 }}
                      className={`text-end`}
                    >
                      <span className="ms-1 d-table-cell">
                        <Mail
                          size={30}
                          className="mx-auto"
                        />
                      </span>
                    </Col>
                    <Col
                      lg={{ size: 11, order: 0 }}
                      md={{ size: 10, order: 1 }}
                      xs={{ size: 10, order: 1 }}
                    >
                      <span>Enviar correo electronico a </span>
                      <br />
                      <strong>{dataOTP?.email}</strong>
                    </Col>
                  </Row>
                </ListGroupItem>

                <ListGroupItem
                  action
                  tag="a"
                  href="#!"
                  style={{
                    backgroundColor: selected === 'phone' && '#2356b3',
                    color: selected === 'phone' && '#fff',
                  }}
                  onClick={(e) => {
                    e.preventDefault()
                    setSelected('phone')
                  }}
                >
                  <Row>
                    <Col
                      lg={{ size: 1, order: 0 }}
                      md={{ size: 2, order: 0 }}
                      xs={{ size: 2, order: 0 }}
                      className={`text-end`}
                    >
                      <span className="ms-1 d-table-cell">
                        <Smartphone
                          size={30}
                          className="mx-auto"
                        />
                      </span>
                    </Col>
                    <Col
                      lg={{ size: 11, order: 0 }}
                      md={{ size: 10, order: 1 }}
                      xs={{ size: 10, order: 1 }}
                    >
                      <span>Enviar mensaje a </span>
                      <br />
                      <strong>+{dataOTP?.phone}</strong>
                    </Col>
                  </Row>
                </ListGroupItem>
              </ListGroup>
            </>
          )}

          {!loading && sent && (
            <div className="row">
              <div className="col-12 px-2 text-center">
                <Alert color="success">
                  <div className="alert-body py-3">
                    <CheckCircle size={32} />
                    <h3 className="text-success pt-2">
                      Código ha sido enviado!
                    </h3>
                  </div>
                </Alert>
              </div>
            </div>
          )}

          <hr />
        </CardBody>
        <CardFooter className="border-0">
          <div className="d-flex justify-content-between">
            {!sent && (
              <>
                {' '}
                <Button
                  color="primary"
                  disabled={!showTC}
                  className={'btn-prev'}
                  onClick={() => stepper.previous()}
                >
                  <ArrowLeft
                    size={14}
                    className="align-middle me-sm-25 me-0"
                  ></ArrowLeft>
                  <span className="align-middle d-sm-inline-block d-none">
                    Anterior
                  </span>
                </Button>
                <Button
                  type="button"
                  color="primary"
                  className={'btn-next'}
                  disabled={!selected}
                  onClick={generateOTP}
                >
                  <span className="align-middle d-sm-inline-block d-none">
                    Siguiente
                  </span>
                  <ArrowRight
                    size={14}
                    className="align-middle ms-sm-25 ms-0"
                  ></ArrowRight>
                </Button>
              </>
            )}
          </div>
        </CardFooter>
      </Card>
    </div>
  )
}

export default SendingOTP
